import React from "react";
import { useQuery } from "react-apollo";
import { LIST_SMALL } from "../../../../queries/patient-risk.query";
import { toast } from "react-toastify";
import { CleanMessage } from "../../../../util/app";
import LoadingSpinner from "../../../../partials/loading";

const PatientRiskInformation = ({ item }) => {
  const { loading, data } = useQuery(LIST_SMALL, {
    onError: e => toast.error(CleanMessage(e.message)),
    variables: { patient: item }
  });
  return (
    <>
      <LoadingSpinner loading={loading} bar={true} />
      {data && (
        <ul className="list-group">
          {data.GetPatientRisks.docs.map(i => (
            <li className="list-group-item list-group-item-danger" key={i.id}>
              {i.risk}
            </li>
          ))}
          {data.GetPatientRisks.docs.length < 1 && <li className="list-group-item list-group-item-success">No Risk Recorded!</li>}
        </ul>
      )}
    </>
  );
};

export default PatientRiskInformation;
